import { inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { EndPoints } from '../services/EndPoints';
import {
  AdminRevenueEvolutionResponseDTO,
  AdminSummaryResponseDTO,
  ClientExpensesEvolutionResponseDTO,
  ClientSummaryResponseDTO,
  DashboardFilterDTO,
  DashboardTemporalFilterDTO
} from '../dtos/dashboard/dashboard.dtos';

@Injectable({ providedIn: 'root' })
export class DashboardProvider {
  private readonly api = inject(ApiService);

  getAdminSummary(filter: DashboardFilterDTO): Observable<AdminSummaryResponseDTO> {
    return from(this.api.post<AdminSummaryResponseDTO>({
      url: EndPoints.DASHBOARD_ADMIN_SUMMARY,
      body: filter
    }));
  }

  getAdminRevenueEvolution(filter: DashboardTemporalFilterDTO): Observable<AdminRevenueEvolutionResponseDTO> {
    return from(this.api.post<AdminRevenueEvolutionResponseDTO>({
      url: EndPoints.DASHBOARD_ADMIN_REVENUE_EVOLUTION,
      body: filter
    }));
  }

  getClientSummary(filter: DashboardFilterDTO): Observable<ClientSummaryResponseDTO> {
    return from(this.api.post<ClientSummaryResponseDTO>({
      url: EndPoints.DASHBOARD_CLIENT_SUMMARY,
      body: filter
    }));
  }

  getClientExpensesEvolution(filter: DashboardTemporalFilterDTO): Observable<ClientExpensesEvolutionResponseDTO> {
    return from(this.api.post<ClientExpensesEvolutionResponseDTO>({
      url: EndPoints.DASHBOARD_CLIENT_EXPENSES_EVOLUTION,
      body: filter
    }));
  }
}
